import React from 'react';
import { lazyAfterPaint } from 'react-loosely-lazy';
import { Skeleton } from '@atlassian/jira-common-components-skeleton';
import Placeholder from '@atlassian/jira-placeholder';
import type { Props } from './issue-search';
import { SkeletonWrapper } from './issue-search/view';

const LazyComponent = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-queues-agent-view-issue-search" */ './issue-search'),
);

const Component = (props: Props) => (
	<Placeholder
		name="queues-agent-view-issue-search"
		fallback={
			<SkeletonWrapper>
				<Skeleton height="32px" width="240px" />
			</SkeletonWrapper>
		}
	>
		<LazyComponent {...props} />
	</Placeholder>
);

export default Component;
